import React, { useState } from 'react';

function Tooltip(props) {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTouchStart = () => {
    setShowTooltip(true);
  };

  const handleTouchEnd = () => {
    setTimeout(() => setShowTooltip(false), 2000); // Auto hide after 2 seconds on mobile
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{ display: 'inline-block', position: 'relative' }}
    >
      {props.children}
      {showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#616161',
            color: 'white',
            padding: '0.5rem',
            borderRadius: '0.25rem',
            display: 'inline-block',
            zIndex: 1000,
            maxWidth: '200px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            fontSize: '12px',
            lineHeight: 1.3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          {props.text}
        </div>
      )}
    </div>
  );
}

export default Tooltip;
